import React from 'react';
import { motion } from 'framer-motion';
import { HiExclamationCircle } from 'react-icons/hi';

const AlertMessages = ({ warning, error }) => {
  return (
    <>
      {/* Warning message */}
      {warning && (
        <motion.div
          className={`warning-message ${warning.type}`}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <HiExclamationCircle />
          <span>{warning.message}</span>
        </motion.div>
      )}

      {/* Error message */}
      {error && (
        <motion.div
          className="error-message"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <HiExclamationCircle />
          <span>{error}</span>
        </motion.div>
      )}
    </>
  );
};

export default AlertMessages; 